import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-bootstrap/esm/Col.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/react-bootstrap/esm/Container.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/react-bootstrap/esm/Row.js");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/about/about-hero.png");
;
import(/* webpackMode: "eager" */ "/app/public/assets/images/privacy-policy/privacy-policy.png");
